import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { SR_API_ACTION_UPDATE_BREED_RESTRICTIONS } from 'api/actionTypes';

import branch from 'client/core/branch';
import postWithState from 'client/actions/postWithState';
import getBreedRestrictionsAction from 'client/actions/TenantScreeningCriteria/getBreedRestrictions';

import SrEditBreedRestrictionsModal from 'client/components/SrEditBreedRestrictionsModal';

@branch((props) => {
  if (props.listingId) {
    return {
      listingBreedRestrictions: ['breedRestrictions', 'byListingId', props.listingId],
    };
  }
  return {};
})
class SrEditListingBreedRestrictionsCta extends Component {
  static propTypes = {
    listingId: PropTypes.number,
    listingBreedRestrictions: PropTypes.array,
    onSubmit: PropTypes.func,
    dispatch: PropTypes.func.isRequired,
    children: PropTypes.node.isRequired,
    preserveEditBreedRestrictionValues: PropTypes.bool,
  };

  constructor(props) {
    super(props);
    this.state = {
      breedRestrictionsModalIsOpen: false,
    };
  }

  componentDidMount() {
    const { listingId, dispatch } = this.props;
    if (listingId) {
      dispatch(getBreedRestrictionsAction, {
        listingId: listingId,
        reload: true,
        withPartnerCascade: true,
      });
    }
  }

  _onEditBreedRestrictions = () => {
    this.setState({
      breedRestrictionsModalIsOpen: true,
    });
  };

  _onCloseBreedRestrictionsModal = () => {
    this.setState({
      breedRestrictionsModalIsOpen: false,
    });
  };

  _onBreedRestrictionsModalSubmit = (breedRestrictions) => {
    const { listingId, onSubmit, dispatch } = this.props;

    if (onSubmit) {
      this.setState({
        editBreedRestrictionValues: breedRestrictions,
      });
      onSubmit(breedRestrictions);
    }

    if (listingId) {
      dispatch(postWithState, {
        action: SR_API_ACTION_UPDATE_BREED_RESTRICTIONS,
        payload: {
          listingId: listingId,
          breedRestrictions,
        },
        onSuccess: () => {
          dispatch(getBreedRestrictionsAction, {
            listingId: listingId,
            reload: true,
            withPartnerCascade: true,
          });
          this._onCloseBreedRestrictionsModal();
        },
      });
    } else {
      this._onCloseBreedRestrictionsModal();
    }
  };

  render() {
    const { children, listingBreedRestrictions, preserveEditBreedRestrictionValues } = this.props;
    const { breedRestrictionsModalIsOpen, editBreedRestrictionValues } = this.state;

    const initialBreedNamesEnabled = listingBreedRestrictions?.map(({ name }) => name) || [];

    return (
      <div className="SrEditListingBreedRestrictionsCta">
        <span onClick={this._onEditBreedRestrictions}>{children}</span>
        {breedRestrictionsModalIsOpen && (
          <SrEditBreedRestrictionsModal
            initialBreedNamesEnabled={
              preserveEditBreedRestrictionValues
                ? editBreedRestrictionValues || []
                : initialBreedNamesEnabled
            }
            onSubmit={this._onBreedRestrictionsModalSubmit}
            onClose={this._onCloseBreedRestrictionsModal}
          />
        )}
      </div>
    );
  }
}

SrEditListingBreedRestrictionsCta.displayName = 'SrEditListingBreedRestrictionsCta';

export default SrEditListingBreedRestrictionsCta;
